<template>
  <div class="QRCode">

    <!-- 选择区 -->
    <div class="selectionArea search_box">

      <div class="item">
        <!-- <span class="title">状态</span> -->
        <el-select v-model="parameter.status" placeholder="请选择状态">
          <el-option
            v-for="item in states"
            :key="item.id"
            :label="item.value"
            :value="item.id"
          />
        </el-select>
      </div>

      <div class="item">
        <!-- <span class="title">设备编码</span> -->
        <el-input v-model="parameter.equipment_code" placeholder="请输入设备编码" />
      </div>

      <div class="item">
        <!-- <span class="title">微信号</span> -->
        <el-input v-model="parameter.phone_vx_account" placeholder="请输入微信号" />
      </div>

      <div class="item">
        <!-- <span class="title">管理员id</span> -->
        <el-input v-model="parameter.admin_id" placeholder="请输入管理员id" />
      </div>

      <div class="item">
        <!-- <span class="title">设备编号</span> -->
        <el-input v-model="parameter.phone_name" placeholder="请输入设备编号" />
      </div>
      <div class="item">
        <!-- <span class="title">用途</span> -->
        <el-select v-model="parameter.use_type" placeholder="请选择用途">
          <el-option
            v-for="item in statusoptions"
            :key="item.id"
            :label="item.value"
            :value="item.id"
          />
        </el-select>
      </div>

      <el-button type="primary" icon="el-icon-search" @click="search">搜索</el-button>
      <el-button type="info" icon="el-icon-refresh" @click="reset">重置</el-button>
      <el-button type="success" icon="el-icon-s-help" @click="dialogVisible = true">创建</el-button>
    </div>

    <!-- 主体区 -->
    <div>
      <div
        style="margin-bottom: 10px; font-size: 16px;"
      >
        <span>正在链接数: {{ tableData.connection_num }}</span>
      </div>
      <el-table
        v-loading="loading"
        :data="tableData.list"
        border
        style="width: 100%"
      >
        <el-table-column
          prop="admin_name"
          label="管理员"
          width="100"
          align="center"
        />
        <!-- <el-table-column
          prop="admin_id"
          label="管理id"
          width="180"
        /> -->
        <el-table-column
          prop="equipment_code"
          label="手机设备编码"
          width="180"
          align="center"
          fixed="left"
        />
        <el-table-column
          prop="phone_vx_account"
          label="微信号"
          width="180"
          align="center"
        />
        <el-table-column
          prop="connection_id"
          label="设备链接id"
          width="180"
          align="center"
        />
        <el-table-column
          prop="connection_text"
          label="链接状态"
          width="150"
          align="center"
        >
          <template slot-scope="scope">
            <i v-if="scope.row.connection_status == 2" class="el-icon-success defaultr" />
            <i v-if="scope.row.connection_status == 1" class="el-icon-error stopew" />
            {{ scope.row.connection_text }}
          </template>
        </el-table-column>
        <el-table-column
          prop="last_connection_time_text"
          label="最后心跳时间"
          width="180"
          align="center"
        />
        <el-table-column
          prop="status_text"
          label="手机状态"
          width="100"
          align="center"
        >
          <template slot-scope="scope">
            <i v-if="scope.row.status == 1" class="el-icon-success defaultr" />
            <i v-if="scope.row.status == 2" class="el-icon-error stopew" />
            {{ scope.row.status_text }}
          </template>
        </el-table-column>
        <el-table-column
          prop="phone_name"
          label="手机编号"
          width="100"
          align="center"
        />
        <el-table-column
          prop="use_type_str"
          label="用途"
          width="150"
          align="center"
        />
        <el-table-column prop="lock_screen_password" label="锁屏密码" width="180" align="center" />
        <el-table-column
          prop="created_at_text"
          label="创建时间"
          width="180"
          align="center"
        />
        <el-table-column
          prop="address"
          label="操作"
          min-width="400"
          align="center"
        >
          <template scope="scope">
            <el-button type="warning" size="mini" @click="(check = scope.row),(dialogVisible = true)">修改</el-button>
            <el-button type="danger" size="mini" @click="myDelete(scope.row)">删除</el-button>
            <el-button type="primary" size="mini" @click="relevance(scope.row.id)">关联企业员工</el-button>
            <el-button type="success" size="mini" @click="relevancer(scope.row.id)">查看关联员工</el-button>
          </template>

        </el-table-column>
      </el-table>
    </div>
    <pagination-right
      :total="tableData.total"
      @size-change="fetchPageSize"
      @current-change="fetchCurrentPage"
    />
    <el-dialog
      :title="check ? '更新' : '创建'"
      :visible.sync="dialogVisible"
      :before-close="handleClose"
      :close-on-click-modal="false"
    >
      <TextMessage v-if="dialogVisible" :check="check" @determine="determine" @cancel="dialogVisible = false" />
    </el-dialog>
    <el-dialog
      title="关联企业员工"
      :visible.sync="relevanceVisible"
      :destroy-on-close="true"
      :close-on-click-modal="false"
    >
      <relevancedialog ref="relevanceVisibleview" @updata="updata" />
    </el-dialog>
    <el-dialog
      title="查看关联员工"
      :visible.sync="lookVisible"
      :destroy-on-close="true"
      :close-on-click-modal="false"
    >
      <relist ref="relistview" />
    </el-dialog>
  </div>
</template>

<script>
import PaginationRight from '@/components/PaginationRight/index.vue'
import TextMessage from './components/Message.vue'
import relevancedialog from './components/relevancedialog.vue'
import relist from './components/relist.vue'
import { scanCodeMobilePhoneList, creationOfCodeScanningMobilePhone, modificationOfMobilePhoneScanningCode, codeScanningMobilePhoneDeletion } from '@/api/mobilePhoneScanningCode.js'
export default {
  name: 'MobilePhone',
  components: {
    PaginationRight,
    TextMessage,
    relevancedialog,
    relist
  },
  data() {
    return {
      parameter: {
        equipment_code: null, // 设备编码
        status: null, // 状态
        phone_vx_account: null, // 微信号
        phone_name: null, // 设备编号
        admin_id: null, // 管理员
        use_type: 1,
        page: 1,
        page_size: 10
      },
      loading: false,
      qRCodeType: [{ id: 1, value: '公众号扫码登录' }, { id: 2, value: '鉴权' }, { id: 3, value: '群发' }, { id: 4, value: '其他' }],
      states: [{ id: 1, value: '正常' }, { id: 2, value: '停用' }],
      statusoptions: [{ id: 1, value: '微信扫码' }, { id: 2, value: '企微脚本' }],
      tableData: {
        total: null
      },
      dialogVisible: false,
      check: null,
      relevanceVisible: false,
      lookVisible: false
    }
  },
  created() {
    this.getDatas()
  },
  methods: {
    async getDatas() {
      this.loading = true
      try {
        const data = await scanCodeMobilePhoneList(this.parameter)
        this.tableData = data.data
      } catch (err) {
        this.$message({
          message: err,
          type: 'warning'
        })
      }

      this.loading = false
    },
    fetchPageSize(e) {
      this.parameter.page_size = e
      this.getDatas()
    },

    fetchCurrentPage(e) {
      this.parameter.page = e
      this.getDatas()
    },

    handleClose() {
      this.check = null
      this.dialogVisible = false
    },

    // 删除
    myDelete(row) {
      this.$confirm('此操作将删除此条数据, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        closeOnClickModal: false,
        type: 'warning'
      }).then(() => {
        codeScanningMobilePhoneDeletion({ id: row.id }).then((res) => {
          this.$message({
            type: 'success',
            message: '删除成功!'
          })
          this.getDatas()
        })
      }).catch(() => {
        // this.$message({
        //   type: 'info',
        //   message: '已取消删除'
        // })
      })
    },

    // 提交
    async determine(obj) {
      const bool = this.judgeParameter(obj)
      if (!bool) {
        return
      }
      this.check ? await modificationOfMobilePhoneScanningCode({ ...obj, id: this.check.id }) : await creationOfCodeScanningMobilePhone(obj)
      this.$message({
        message: this.check ? '修改成功' : '创建成功',
        type: 'success'
      })
      this.check = null
      this.dialogVisible = false
      this.getDatas()
    },

    // 判断参数
    judgeParameter(obj) {
      let text = null
      if (!obj.equipment_code) {
        text = '请输入手机设备编码'
      } else if (!obj.phone_vx_account) {
        text = '请输入微信号'
      } else if (!obj.phone_name) {
        text = '请输入手机编号'
      } else if (!obj.use_type) {
        text = '请选择扫码类型'
      }

      text && this.$message({
        message: text,
        type: 'warning'
      })

      return !text
    },

    // 搜索
    search() {
      this.parameter.page = 1
      this.getDatas()
    },

    // 重置
    reset() {
      this.parameter = {
        source_type: null, // 来源
        state: null, // 状态
        phone_vx_account: null, // 微信号
        code_no: null, // 二维码编号
        admin_id: null, // 管理员
        page: 1,
        page_size: 10
      }
      this.getDatas()
    },
    relevance(id) {
      this.relevanceVisible = true
      this.$nextTick(() => {
        this.$refs.relevanceVisibleview.send(id)
      })
    },
    relevancer(id) {
      this.lookVisible = true
      this.$nextTick(() => {
        this.$refs.relistview.send(id)
      })
    },
    updata() {
      this.relevanceVisible = false
      this.getDatas()
      this.$message({
        message: '关联成功',
        type: 'success'
      })
    }
  }
}
</script>

<style scoped>
.QRCode{
   width: 95%;
   margin: 0 auto;
   margin-top: 30px;
}

.selectionArea{
      display: flex;
      flex-wrap: wrap;
      margin-bottom: 30px;
      gap:10px;
}

.item{
  display: flex;
  align-items: center;
}

.title{
       white-space: pre;
       display: inline-block;
       margin-right: 7px;
}
.defaultr{
  color: #67C23A;
}
.stopew{
  color: red;
}
@media (max-width: 768px){
  .title{
    font-size:3vw;
  }
}
</style>
